var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(new Array('User','Corrector', 'Animator', 'Admin', 'SuperAdmin').includes(_vm.profile.role))?_c('v-card',{staticClass:"pa-3"},[_c('v-card-title',[_vm._v("Contacts :")]),_c('v-card-text',[_c('ContactTab',{attrs:{"profile":_vm.profile,"user":_vm.user,"notifications":_vm.notifications,"currentRoom":_vm.currentRoom}})],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }